export default function Reviews() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="relative bg-foreground-950 rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            <div className="lg:w-2/5 relative">
              <div className="aspect-[3/4] lg:aspect-auto lg:h-full overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Confident%20stylish%20European%20person%20wearing%20modern%20fashion%20outfit%2C%20portrait%20photography%20with%20soft%20warm%20lighting%2C%20neutral%20cream%20background%2C%20editorial%20style%2C%20natural%20pose%2C%20clean%20minimalist%20aesthetic%2C%20professional%20yet%20approachable%20look&width=800&height=1000&seq=review-avatar-01&orientation=portrait"
                  alt="OOPBuy Spreadsheet Bewertung"
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>

            <div className="lg:w-3/5 flex flex-col justify-center p-8 md:p-12 lg:p-16">
              <div className="text-accent-400 text-6xl md:text-8xl font-serif leading-none mb-2">&ldquo;</div>
              <p className="text-white/90 text-base md:text-lg leading-relaxed mb-6 max-w-lg">
                Das OOPBuy Spreadsheet hat mir unglaublich geholfen, die besten Produkte zu finden. Die Kategorien sind perfekt organisiert und die QC-Tipps sind Gold wert. Ich nutze es fast täglich für meine Einkäufe.
              </p>
              <div className="mb-6">
                <p className="text-white font-semibold text-sm">Markus K.</p>
                <p className="text-white/50 text-xs">Verifizierter OOPBuy Spreadsheet Nutzer, Berlin</p>
              </div>
              <div className="flex gap-1 mb-6">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-400 text-sm"></i>
                ))}
              </div>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent-500 text-white text-sm font-semibold rounded-full hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap w-fit"
              >
                Alle Bewertungen
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-8">
          {[
            { name: 'Anna S.', role: 'München', text: 'Endlich ein Spreadsheet, das wirklich funktioniert. Die Deutschland-spezifischen Infos sind top!' },
            { name: 'Thomas R.', role: 'Hamburg', text: 'Die besten OOPBuy Spreadsheet Tipps, die ich je gesehen habe. Absolut empfehlenswert für Einsteiger.' },
            { name: 'Laura M.', role: 'Wien', text: 'Perfekt für den DACH-Raum. QC-Guides und Verkäufer-Bewertungen sind extrem hilfreich.' },
          ].map((review, idx) => (
            <div key={idx} className="bg-white rounded-2xl p-5 md:p-6">
              <div className="flex gap-1 mb-3">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-400 text-xs"></i>
                ))}
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed mb-4">&ldquo;{review.text}&rdquo;</p>
              <div>
                <p className="text-foreground-900 font-semibold text-sm">{review.name}</p>
                <p className="text-foreground-400 text-xs">{review.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}